'use client';

import Link from 'next/link';
import Image from 'next/image';
import classes from './PinnacleHero.module.scss';

type PinnacleHeroProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  backgroundImage: string;
  backgroundAlt?: string;
  primaryLabel?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  sidebarLinks?: { label: string; href: string }[];
};

export const PinnacleHero = ({ data }: { data: PinnacleHeroProps }) => {
  const {
    eyebrow,
    title,
    subtitle,
    backgroundImage,
    backgroundAlt,
    primaryLabel,
    primaryHref,
    secondaryLabel,
    secondaryHref,
    sidebarLinks = [],
  } = data;

  return (
    <section className={classes.hero}>
      <Image src={backgroundImage} alt={backgroundAlt ?? title} fill priority className={classes.background} />
      <div className={classes.overlay} />
      <div className={classes.content}>
        <div className={classes.left}>
          {eyebrow && <p className={classes.eyebrow}>{eyebrow}</p>}
          <h1 className={classes.title}>{title}</h1>
          {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
          <div className={classes.actions}>
            {primaryLabel && primaryHref && (
              <Link href={primaryHref} className={`${classes.cta} ${classes.primary}`}>
                {primaryLabel}
              </Link>
            )}
            {secondaryLabel && secondaryHref && (
              <Link href={secondaryHref} className={`${classes.cta} ${classes.secondary}`}>
                {secondaryLabel}
              </Link>
            )}
          </div>
          <div className={classes.scrollCue}>
            <span>scroll down</span>
            <div className={classes.line} />
          </div>
        </div>
        <div className={classes.right} aria-label="Sections rapides">
          <span>Start</span>
          <ul>
            {sidebarLinks.map((link, index) => (
              <li key={link.label}>
                <span>0{index + 1}</span>
                <Link href={link.href}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

